<h2 mat-dialog-title>Compartir pantalla</h2>

<mat-dialog-content>
  <p class="dialog-description">Elige qué pantalla o ventana quieres grabar.</p>

  <mat-radio-group class="source-list" [(ngModel)]="selected_source_id">
    @for (source of data.sources; track source.id) {
      <mat-radio-button class="source-option" [value]="source.id">
        <div class="source-option-content">
          @if (source.thumbnail_data_url) {
            <img class="source-thumbnail" [src]="source.thumbnail_data_url" [alt]="source.name" />
          }
          <span class="source-name">{{ source.name }}</span>
        </div>
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (data.supports_system_audio) {
    <mat-checkbox class="system-audio-checkbox" [(ngModel)]="include_system_audio"> Compartir audio del sistema </mat-checkbox>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="selected_source_id === ''" (click)="confirm()">Compartir</button>
</mat-dialog-actions>
